var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"grid-list":""}},[_c('v-layout',[_c('v-flex',{attrs:{"xs6":""}},[_c('v-card',[_c('v-card-title',{attrs:{"primary-title":""}},[_c('h3',{staticClass:"headline mb-0"},[_vm._v("Mensagens")])]),_c('v-card-text'),_c('v-card-actions')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }